import SuccessPaymentView from "./components/SuccessPaymentView";

export default (store) => ({
  path : 'payment-success',
  component: SuccessPaymentView
})



// WEBPACK FOOTER //
// ./src/routes/SuccessPayment/index.js